import React from 'react';
import TranslatableHelmet from 'components/TranslatableHelmet/index';
import styles from './AccountError.scss';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

export const AccountError = ({ lang }) => (
  <div className={styles.base}>
    <TranslatableHelmet locale={lang} transKey="sign_in.account_error.title" />
    <h2 className="center">
      <FormattedMessage id="sign_in.account_error.title" />
    </h2>
    <div className="text-center">
      <FormattedMessage id="sign_in.account_error.text" />
      <Link to={`/${lang}/tuki/yhteydenotto`}>
        <FormattedMessage id="sign_in.account_error.link_text" />
      </Link>
    </div>
  </div>
);
AccountError.propTypes = {
  lang: PropTypes.string
};

export default AccountError;
